export const AS_HALF_PRODUCT_QUANTITY = 0.5;
export const DELIVERY_SLOT_DEFAULT_STORE = '01';
export const DELIVERY_SLOT_DEFAULT_CHANNEL = 'makropro';
export const DELIVERY_SLOT_FETCH_INTERVAL = 5 * 60 * 1000;

export enum ProductCardVariant {
  NORMAL = 'NORMAL',
  COMPACT = 'COMPACT',
  COMPACT_MINI = 'COMPACT_MINI',
}
